export default class ServiceQueueTypeModel {
  id!: number;

  name!: string;
}
